import { jsx } from 'react/jsx-runtime';
import { SelectableContainerCheckbox } from './SelectableContainerCheckbox.esm.js';
import { SelectableContainerRadio } from './SelectableContainerRadio.esm.js';
import { isRadioType, isCheckboxType } from './utils.esm.js';

const SelectableContainer = (props) => {
    const { variant } = props;
    if (isRadioType(variant)) {
        return (jsx(SelectableContainerRadio, Object.assign({}, props)));
    }
    if (isCheckboxType(variant)) {
        return (jsx(SelectableContainerCheckbox, Object.assign({}, props)));
    }
    return null;
};

export { SelectableContainer };
